/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IoTEventResponse } from '../../models/io-t-event-response';

export interface GetFacilityIotEvents$Params {
  byCustomerTz?: boolean;
  endDate?: string;
  facilityGroupId?: number;
  facilityId?: number;
  numberOfEvents?: number;
  sourceDeviceId?: number;
  startDate?: string;
}

export function getFacilityIotEvents(http: HttpClient, rootUrl: string, params?: GetFacilityIotEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IoTEventResponse>>> {
  const rb = new RequestBuilder(rootUrl, getFacilityIotEvents.PATH, 'get');
  if (params) {
    rb.query('byCustomerTz', params.byCustomerTz, {});
    rb.query('endDate', params.endDate, {});
    rb.query('facilityGroupId', params.facilityGroupId, {});
    rb.query('facilityId', params.facilityId, {});
    rb.query('numberOfEvents', params.numberOfEvents, {});
    rb.query('sourceDeviceId', params.sourceDeviceId, {});
    rb.query('startDate', params.startDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<IoTEventResponse>>;
    })
  );
}

getFacilityIotEvents.PATH = '/api/telemetry/raw/events';
